import { Paper, Group, Title, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

import UploadYieldMapForm from '../upload-yield-map-form/upload-yield-map-form';

import styles from './synthesis-header.module.css';

import { Drawer } from '@ui';

interface SynthesisHeaderProps {
  onExport: () => void;
  preparingSynthesis?: boolean;
}

export function SynthesisHeader({
  onExport,
  preparingSynthesis,
}: SynthesisHeaderProps) {
  const { t } = useTranslation();
  const [opened, actions] = useDisclosure(false);

  return (
    <>
      <Paper>
        <Group justify="space-between">
          <Title order={2}>{t('synthesis.title')}</Title>
          <Group>
            <Button
              color="red.9"
              disabled={true}
              loading={preparingSynthesis}
              onClick={onExport}
            >
              {t('synthesis.download')}
            </Button>
            <Button color="red.9" onClick={actions.open}>
              {t('synthesis.import')}
            </Button>
          </Group>
        </Group>
      </Paper>
      <Drawer
        onClose={actions.close}
        opened={opened}
        position="right"
        title={t('synthesis.import')}
      >
        <UploadYieldMapForm />
      </Drawer>
    </>
  );
}

export default SynthesisHeader;
